import {ReportBox, ReportBoxItemTypes} from "../../raikoComponents/reportBox/ReportBox";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSectionContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import React from "react";
import {css} from "@emotion/css";
import {TourismReportService} from "../../serverService/tourism/TourismReportService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {doDownloadFile} from "../../util/DownloadHelper";

export default function TourismReports() {

    const service = new TourismReportService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    function handleDownloadPlaces(type) {
        loading.show()
        service.getTourismListReport()
            .then(result => {
                doDownloadFile(result,`گزارش گیری مکان های گردشگری`,type)
            }).catch(error => {
            showServerErrorMessage(error)
        }).finally(() => {
            loading.hide()
        })
    }

    function handleDownloadPlaceCategory(type) {
        loading.show()
        service.getCategoryReport()
            .then(result => {
                doDownloadFile(result,`گزارش گیری دسته بندی ها`,type)
            }).catch(error => {
            showServerErrorMessage(error)
        }).finally(() => {
            loading.hide()
        })
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.TourismReport.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Tourism.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.TourismReport.name,
                                ""
                            ),
                        ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"گزارش گیری"}
                            subTitle={"پشتیبان گیری از کلیه ی اطلاعات وارد شده در قسمت گردشگری"}
                        >
                            <RaikoGridTwoColumn>
                                <ReportBox
                                    types={[ReportBoxItemTypes.XLSX]}
                                    label={"گزارش گیری مکان های گردشگری ( زبان فارسی 🇮🇷 )"}
                                    handleOnClick={handleDownloadPlaces}
                                />
                                <ReportBox
                                    types={[ReportBoxItemTypes.XLSX]}
                                    label={"گزارش گیری دسته بندی ها ( زبان فارسی 🇮🇷 )"}
                                    handleOnClick={handleDownloadPlaceCategory}
                                />
                            </RaikoGridTwoColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}